import Backend from 'App/Dataman-Backend';
import { apiGet, apiPatch, apiDelete, ApiError } from '@/app/api/core/http';
import { uploadFile } from '@/app/api/core/images';
import { CAT_FILES } from 'App/utils/Collections';
import { FILES_PATHS } from './paths';

// Download logging is only expected for entity-owned files
const LOGGABLE_LINK_PARTS = ['companies', 'products', 'components', 'events'];

export const filesApiAdapter = {
  [CAT_FILES]: {
    getList: (params) => apiGet(FILES_PATHS.files + FILES_PATHS.suffix, { params }),
    getItem: (id, params) => apiGet(`${FILES_PATHS.files}/${id}`, { params }),
    download: (link) => {
      let params = { url: `${FILES_PATHS.host}${link}`, auth: true, headers: { 'WIMS-loggable': true } };
      if (!LOGGABLE_LINK_PARTS.some((part) => link.includes(part))) {
        delete params.headers;
      }
      return Backend.loadData(params).then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw new ApiError('Error', res);
        }
      });
    },
    downloadBlob: (link) => {
      let params = { url: `${FILES_PATHS.host}${link}`, auth: true, headers: { 'WIMS-loggable': true } };
      return Backend.loadBlobData(params).then((res) => {
        if (res.status === 200) {
          return res;
        } else {
          throw new ApiError('Error', res);
        }
      });
    },
    update: (id, data) => apiPatch(`${FILES_PATHS.files}/${id}`, { data }),
    create: uploadFile,
    remove: (id) => apiDelete(`${FILES_PATHS.files}/${id}`),
  },
};

export const filesFilterAdapter = {
  getFilesGroups: (params) => apiGet(FILES_PATHS.filesGroups, { params }),
};
